import React from 'react'
import { WidgetHOC, WidgetProps } from './WidgetHOC'

const OverviewContainer = React.lazy(() =>
  import('@features/overview-widget/Overview').then(m => ({ default: m.Overview }))
)

export const OverviewWidget: React.FC<WidgetProps> = props => {
  const { widgetContext } = props
  return (
    <WidgetHOC widgetContext={widgetContext}>
      <OverviewContainer />
    </WidgetHOC>
  )
}
